import { useState } from "react";
import { Button } from "primereact/button";
import { API } from "./App";
import { getAuthHeader } from "./AuthRoute";

function ExportSondagesButton() {
  const [loading, setLoading] = useState(false);

  const handleExport = () => {
    setLoading(true);
    fetch(API() + "/sondages/export-all-sondages-excel", {
      headers: { Authorization: getAuthHeader() },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Export failed");
        return res.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "all_sondages_export.xlsx";
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch((err) => alert(err.message))
      .finally(() => setLoading(false));
  };

  return (
    <Button
      label="Export All as Excel"
      icon="pi pi-download"
      onClick={handleExport}
      loading={loading}
      disabled={loading}
      style={{ marginBottom: "10px" }}
    />
  );
}

export default ExportSondagesButton;
